import React from "react";
import image1 from "./assets/images/image1.webp";
import { NavLink } from "react-router-dom";
import Ramnavami from "./assets/images/ramnavami.webp";
import ChandanYatra from "./assets/images/ChandanYatraBG.webp";
import Narasimha from "./assets/images/NARASHIMA.jpg";
import Krishna from "./0O4A64392.JPG";
import NewBanner from "./NewBanner.jpg";
import CultureCamp from "./assets/images/Cultural-Camp.webp";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import banner from "../../../GauSeva/assets/GauSevaNew.png";
import Ffl from "../../../FoodForLife/assets/images/foodForLifeNew.jpg";
import janmashami from "../../../Janmashtami2025/Hero/assets/Banner.webp";


import "./ImageSlider.css";

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const slides = [
    // {
    //   img: CultureCamp,
    //   link: 0,
    // },
    // {
    //   img: ChandanYatra,
    //   link: "/ChandanYatra",
    // },
    // {
    //   img: Narasimha,
    //   link: "/NarasimhaChaturdashi",
    // },
    // {
    //   img: Krishna,
    //   // link: "/rathyatra",
    // },

    {
      img: janmashami,
      link: "/janmashtami2025",
      alt: "Krishna Janmastami 2025"
    },
    {
      img: banner,
      link: "/GauSeva",
      alt: "Gauseva"
    },
    {
      img: Ffl,
      link: "/food-for-life",
      alt: "food for life"
    },

    // {
    //   img: Ramnavami,
    //   link: "/RamNavami",
    // },

    // {
    //   img: image1,
    //   link: "https://www.iskconvjagita4you.org",
    // },

  ];

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, []);
  const nextSlide = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setIsAutoPlaying(false);
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  return (
    <>
      <div className="imgSlider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`imgSlider-slide ${index === currentSlide ? "imgSlider-active" : "imgSlider-hidden"
              }`}
          >
            <Link to={slide.link} className="imgSlider-link">
              <div className="imgSlider-imgWrapper">
                <img
                  loading="lazy"
                  decoding="async"
                  src={slide.img}
                  alt={slide.alt}
                  className="imgSlider-img"
                />
              </div>
            </Link>
          </div>
        ))}

        <button onClick={prevSlide} className="imgSlider-btn imgSlider-btn-left">
          ❮
        </button>
        <button onClick={nextSlide} className="imgSlider-btn imgSlider-btn-right">
          ❯
        </button>

        <div className="imgSlider-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setIsAutoPlaying(false);
                setCurrentSlide(index);
              }}
              className={`imgSlider-dot ${index === currentSlide ? "imgSlider-dot-active" : ""
                }`}
            />
          ))}
        </div>
      </div>

    </>

  );
};

export default ImageSlider;        